import React from 'react';
import Slider from 'react-slick';
import './BusAmenities.css';
import '../../styles/slick.css';
import '../../styles/slick-theme.css';
import { BusAmenities } from '../../pages/runtime-typechecker';

type BusAmenitiesProps = {
  busAmenities: BusAmenities[];
};

const SampleNextArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} style={{ display: 'flex' }} onClick={onClick}>
      <button></button>
    </div>
  );
};

const SamplePrevArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} style={{ display: 'flex' }} onClick={onClick}>
      <button></button>
    </div>
  );
};

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  className: '',
  slidesToShow: 9,
  swipeToSlide: true,
  slidesToScroll: 1,
  adaptiveHeight: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />
};

const BusAmenitiesList = ({ busAmenities }: BusAmenitiesProps) => {
  return busAmenities.length <= 9 ? (
    //if no of amenities <=9 maintain centre alignment
    <div className="makeFlex amenitiesWrap clearFix">
      <div
        style={{ marginLeft: 'auto', marginRight: 'auto' }}
        className="makeFlex amenitiesSlickCarousel"
      >
        {busAmenities.map(({ name, url }, idx) => (
          <div className="amenitiesCard" key={`amenity_` + idx}>
            <span className="amenitiesIconWrap appendBottom5">
              <img
                className="lazyload"
                width="36px"
                height="36px"
                data-src={url}
                alt="bus amenities"
              />
            </span>
            <p className="textCenter font14 lineHeight17">{name}</p>
          </div>
        ))}
      </div>
    </div>
  ) : (
    //else use react-slick component
    <div className="amenitiesWrap clearFix">
      <div className="amenitiesSlickCarousel makeRelative">
        <Slider {...settings}>
          {busAmenities.map(({ name, url }, idx) => (
            <div className="amenitiesCard" key={`amenity_` + idx}>
              <span className="amenitiesIconWrap appendBottom5">
                <img
                  className="lazyload"
                  width="36px"
                  height="36px"
                  data-src={url}
                  alt="bus amenities"
                />
              </span>
              <p className="textCenter font14 lineHeight17">{name}</p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default BusAmenitiesList;
